<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" :size="iconSize" :color="colour">{{
        icon
      }}</v-icon>
    </template>
    <span>{{ status | pascalToReadable }}</span>
  </v-tooltip>
</template>

<script>
import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';

export default {
  name: 'PassengerStatusIcon',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  mixins: [ResponsiveSizeHelperMixin],
  computed: {
    icon() {
      switch (this.status) {
        case 'AwaitingPickup':
          return 'mdi-account-clock';
        case 'OnBoard':
          return 'mdi-ferry';
        case 'VoyageComplete':
          return 'mdi-check';
        default:
          return '';
      }
    },
    colour() {
      switch (this.status) {
        case 'AwaitingPickup':
          return 'warning';
        case 'OnBoard':
          return 'success';
        case 'VoyageComplete':
          return 'success';
        default:
          return 'warning';
      }
    },
  },
};
</script>
